import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContCreateTechSection,
  CreateTechContent,
  ImageSection,
  MainImage,
  TextSection,
  TitleSection,
  DescSection,
  CardsGrid,
  TechCard,
  CardIcon,
  CardText
} from './CoreBancarioCreateTech.styles';

// Importar iconos SVG
import CreditCardIcon from '../../assets/images/CoreBankingModulesImages/createTech/Credit card.svg';
import DollarSquareIcon from '../../assets/images/CoreBankingModulesImages/createTech/Dollar-square.svg';
import EmptyWalletIcon from '../../assets/images/CoreBankingModulesImages/createTech/Empty-wallet.svg';
import MoneyIcon from '../../assets/images/CoreBankingModulesImages/createTech/Money.svg';
import SecurityCardIcon from '../../assets/images/CoreBankingModulesImages/createTech/Security-card.svg';
import WalletIcon from '../../assets/images/CoreBankingModulesImages/createTech/Wallet_alt.svg';

// Importar imagen principal
import LeftImage from '../../assets/images/CoreBankingModulesImages/createTech/left_image.webp';
import LeftImageMobile from '../../assets/images/CoreBankingModulesImages/createTech/left_image_mobile.webp';

const techCards = [
  {
    id: 1,
    icon: CreditCardIcon,
    text: 'SOFOM',
  },
  {
    id: 2,
    icon: DollarSquareIcon,
    text: 'SOFIPO',
  },
  {
    id: 3,
    icon: EmptyWalletIcon,
    text: 'Fintech',
  },
  {
    id: 4,
    icon: MoneyIcon,
    text: 'IFPE',
  },
  {
    id: 5,
    icon: SecurityCardIcon,
    text: 'Financiera',
  },
  {
    id: 6,
    icon: WalletIcon,
    text: 'Arrendadora',
  },
];

export const CoreBancarioCreateTech = () => {
  const { t } = useTranslation();

  return (
    <ContCreateTechSection>
      <CreateTechContent>
        <ImageSection>
          <picture>
            <source media="(max-width: 767px)" srcSet={LeftImageMobile} />
            <MainImage src={LeftImage} alt="Core Bancario" />
          </picture>
        </ImageSection>

        <TextSection>
          <TitleSection>
            {t('Creamos tecnología para liderar la transformación financiera')}
          </TitleSection>
          <DescSection>
            {t('Nuestro Core Bancario está diseñado para impulsar a entidades financieras y empresas que buscan eficiencia operativa e innovación.')}
          </DescSection>

          <CardsGrid>
            {techCards.map((card) => (
              <TechCard key={card.id}>
                <CardText>{t(card.text)}</CardText>
                <CardIcon>
                  <img src={card.icon} alt={card.text} />
                </CardIcon>
              </TechCard>
            ))}
          </CardsGrid>
        </TextSection>
      </CreateTechContent>
    </ContCreateTechSection>
  );
};
